import { render, staticRenderFns } from "./reply-detail.vue?vue&type=template&id=afefdc02"
import script from "./reply-detail.vue?vue&type=script&lang=js"
export * from "./reply-detail.vue?vue&type=script&lang=js"
import style0 from "./reply-detail.vue?vue&type=style&index=0&id=afefdc02&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports